// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__pj7Ls","buyCryptoButton":"styles_buyCryptoButton__rXbC9"};